import { t } from '@lingui/macro';
import { Alert } from '@pocketlaw/tetris';
export function NoProvidersAlert() {
    return (<Alert appearance="info" message={t({
            message: 'No e-signing providers available',
            comment: 'If there are no e-signing providers to select from',
        })}/>);
}
